import { useState, useEffect } from 'react';
import axios from 'axios';
import EmployeeLayout from '../../components/layout/EmployeeLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ClipboardList, ExternalLink, FileText } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmployeeDutyReportsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/duty-reports`)
      .then((res) => setReports(res.data || []))
      .catch(() => toast.error('Failed to load reports'))
      .finally(() => setLoading(false));
  }, []);

  const openReport = (report) => {
    axios.post(`${API}/duty-reports/${report.id}/open`).catch(() => {});
    window.open(report.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <EmployeeLayout>
      <div className="p-4 sm:p-6 space-y-4 max-w-3xl mx-auto">
        <div className="border-b border-border pb-4 flex items-center gap-3">
          <ClipboardList className="w-6 h-6 text-primary" strokeWidth={1.5} />
          <div>
            <h1 className="text-2xl font-barlow tracking-widest text-foreground">DUTY REPORTS</h1>
            <p className="text-xs text-muted-foreground mt-1">Open a report, fill it in and submit.</p>
          </div>
        </div>

        {loading ? (
          <p className="text-sm text-muted-foreground" data-testid="duty-reports-loading">Loading…</p>
        ) : reports.length === 0 ? (
          <Card className="rounded-sm border-border">
            <CardContent className="py-10 text-center" data-testid="duty-reports-empty">
              <FileText className="w-8 h-8 text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
              <p className="text-sm text-muted-foreground">No reports available yet. Check back later.</p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-3">
            {reports.map((r) => (
              <Card key={r.id} className="rounded-sm border-border hover:border-primary/50 transition-colors" data-testid={`duty-report-card-${r.id}`}>
                <CardContent className="p-4 flex items-center gap-4">
                  <div className="p-2.5 rounded-sm bg-primary/10 text-primary flex-shrink-0">
                    <FileText className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-barlow tracking-widest uppercase text-foreground">{r.title}</p>
                    {r.description && <p className="text-xs text-muted-foreground mt-0.5">{r.description}</p>}
                  </div>
                  <Button
                    onClick={() => openReport(r)}
                    data-testid={`open-report-btn-${r.id}`}
                    className="bg-primary text-primary-foreground hover:bg-yellow-300 rounded-sm flex-shrink-0"
                  >
                    <ExternalLink className="w-4 h-4 mr-2" /> Open
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </EmployeeLayout>
  );
}
